<template>
  <el-container class="home-container">
    <el-header height="70px">
      <div class="debug-control" :class="showSocketStatus ? '' : 'hidden'">
        <i class="el-icon-view" @dblclick="showServiceVersion"></i>
        <i class="el-icon-warning-outline" v-if="errorTips" @dblclick="showErrorInfo"></i>
        <i class="el-icon-setting" v-if="languages.repairTool !== ''" @dblclick="downFixTool"></i>
        <i class="el-icon-delete" @dblclick="cleanStorage"></i>
        <i class="el-icon-pie-chart" v-if="debugCount >= 5 || mockMode" @dblclick="showDebug"></i>
      </div>
      <div class="show-socket" @dblclick="showSocketStatus = !showSocketStatus"></div>
      <img
        class="icon-idesk"
        v-if="pageNow === 'HomeGrid'"
        src="~assets/pics/idesk_logo.png"
        disabled
        alt="idesk"
      />
      <div class="socket-container">
        <el-tooltip :content="warnTips" placement="bottom" popper-class="tooltip-style">
          <div class="status-warn">
            <i class="el-icon-warning" v-if="warnTips !== ''"></i>
          </div>
        </el-tooltip>
        <el-tooltip
          :content="languages.lan == 'en' ? item.ename : item.cname"
          placement="bottom"
          popper-class="tooltip-style"
          v-for="item in socketStatus"
          :key="item.port"
        >
          <div class="status-detail" :class="showSocketStatus ? '' : 'hidden'">
            <i class="status-name" :class="'el-icon-' + item.icon"></i>
            <i class="status-state" :class="'el-icon-' + getStateType(item)"></i>
          </div>
        </el-tooltip>
      </div>
      <el-tooltip
        :content="languages.return"
        v-if="pageNow !== 'HomeGrid' && !upgradeChecking"
        :visible-arrow="false"
        placement="bottom"
        popper-class="tooltip-style"
      >
        <img
          class="icon-gohome"
          v-bind:class="isRunning || isErrorPage ? 'button-disable' : ''"
          src="~assets/pics/idesk_back.png"
          @click="goHome"
          disabled
          alt="idesk"
        />
      </el-tooltip>
      <div class="soft-search" :hidden="pageNow !== 'SoftwareUninstall'">
        <el-input
          size="small"
          :disabled="isRunning"
          :placeholder="languages.searchtip"
          prefix-icon="el-icon-search"
          :value="uninstallSearchValue"
          clearable
          @input="handleUninstallSearch"
        ></el-input>
      </div>
      <div class="soft-search" :hidden="searchHidden">
        <el-input
          size="small"
          :disabled="isRunning"
          :placeholder="languages.searchtip"
          prefix-icon="el-icon-search"
          :value="searchValue"
          clearable
          @input="handleSearch"
        ></el-input>
      </div>
      <div
        class="button-apply"
        :hidden="searchHidden"
        @click="goSoftwareApply"
        v-bind:class="[
          languages.lan == 'en' ? 'button-apply-eng' : '',
          isRunning ? 'button-disable' : '',
        ]"
      >
        {{ languages.moreApply }}
      </div>
      <div
        class="button-license"
        :hidden="searchHidden"
        @click="showMyLicenseDialog = true"
        v-bind:class="[
          languages.lan == 'en' ? 'button-apply-eng' : '',
          isRunning ? 'button-disable' : '',
        ]"
      >
        <img src="~assets/pics/auth.png" alt="" />
        {{ languages.myLicense }}
      </div>
      <el-tooltip
        :content="languages.conf"
        :visible-arrow="false"
        placement="bottom"
        popper-class="tooltip-style"
      >
        <img
          class="icon-help"
          src="~assets/pics/conf.png"
          v-bind:class="isRunning ? 'button-disable' : ''"
          @click="openConf"
          alt="service"
        />
      </el-tooltip>
      <el-tooltip
        :content="languages.helpdesk"
        :visible-arrow="false"
        placement="bottom"
        popper-class="tooltip-style"
      >
        <img
          class="icon-service"
          src="~assets/pics/Helpdesk.png"
          v-bind:class="isRunning ? 'button-disable' : ''"
          @click="openAIChat"
          alt="service"
        />
      </el-tooltip>
      <el-tooltip
        :content="languages.language"
        :visible-arrow="false"
        placement="bottom"
        v-if="languages.lan === 'cn'"
        popper-class="tooltip-style"
      >
        <img
          class="icon-lan"
          src="~/assets/pics/lan_cn.png"
          alt="lan"
          v-if="languages.lan === 'cn'"
          v-bind:class="isRunning || !lanChange ? 'button-disable' : ''"
          @click="handleLanChange"
        />
      </el-tooltip>
      <el-tooltip
        :content="languages.language"
        :visible-arrow="false"
        placement="bottom"
        v-if="languages.lan === 'en'"
        popper-class="tooltip-style"
      >
        <img
          class="icon-lan"
          src="~/assets/pics/lan_en.png"
          alt="lan"
          v-if="languages.lan === 'en'"
          v-bind:class="isRunning || !lanChange ? 'button-disable' : ''"
          @click="handleLanChange"
        />
      </el-tooltip>
      <el-tooltip
        :content="languages.home"
        :visible-arrow="false"
        placement="bottom"
        popper-class="tooltip-style"
      >
        <img
          class="icon-home"
          :hidden="homeHidden"
          src="~/assets/pics/home.png"
          v-bind:class="isRunning ? 'button-disable' : ''"
          @click="goHome"
          alt="home"
        />
      </el-tooltip>
    </el-header>
    <el-container>
      <el-main>
        <router-view></router-view>
        <footer class="soft-footer" :class="showFooter ? '' : 'hidden'">
          <el-tooltip
            class="item"
            effect="light"
            :content="downloadSource"
            :disabled="footerTips === '' && !isAuthTab"
            placement="top"
          >
            <span class="footer-tips">{{ footerTips }}</span>
            <span class="footer-policy" v-if="footerTips === '' && !isAuthTab && softCount !== 0">
              {{ languages.softInstall ? languages.softInstall.policy : '' }}
            </span>
          </el-tooltip>
          <span class="footer-warn" v-if="footerTips === ''">{{ footerWarn }}</span>
          {{ languages.softInstall ? languages.softInstall.total : '' }}: {{ softCount }}
        </footer>
      </el-main>
    </el-container>
    <ad-dialog :language="languages.lan" :show="dialogAdVisible"></ad-dialog>
  </el-container>
</template>

<script>
import { Loading } from 'element-ui';
import homeMock from 'components/mocks/homeMock.json';
import AdDialog from 'components/dialogs/AdDialog.vue';
import { mapState, mapMutations, mapActions } from 'vuex';
import socket from 'common/socket';
import tools from 'common/tools';
import { ubtRegister, ubtSendTrace } from 'utils/ubt';
import sendWebVitalsData from '@ctrip/nfes-vitals';

export default {
  data() {
    return {
      showMyLicenseDialog: false,
      debugCount: 0,
      loading: '',
      socketConnectInterval: '',
      intervalCount: 0,
      searchTimeout: '',
      uninstallDatas: '',
      isVersionChecking: false,
      dialogAdVisible: false,
      isSearching: null,
      showSocketStatus: false,
      initPromise: '',
      updatePromise: '',
      localDetails: '',
      mainServiceVer: '',
      routeState: '',
      pvId: '',
      restartSoftModelInterval: null,
    };
  },
  provide() {
    return {
      homeTemplate: this,
    };
  },
  components: {
    AdDialog,
  },
  computed: {
    ...mapState([
      'pageNow',
      'lanChange',
      'errorTips',
      'warnTips',
      'isTripPc',
      'isTestUser',
      'languages',
      'languageDatas',
      'homeHidden',
      'selectSoftDetails',
      'searchHidden',
      'showFooter',
      'softCount',
      'userInfo',
      'deviceName',
      'searchValue',
      'serviceVersion',
      'softVersion',
      'softTypeList',
      'softTotalDetailDatas',
      'grayList',
      'isRunning',
      'isErrorPage',
      'serviceDetails',
      'maxServiceVer',
      'serviceList',
      'authNodeData',
      'testTypeId',
      'mockMode',
      'footerTips',
      'downloadSource',
      'footerWarn',
      'internetAuth',
      'isAdministrator',
      'UacStatus',
      'recommendSoftware',
      'recommendSoftwareEn',
      'redirectMode',
      'isAuthTab',
      'socketStatus',
      'isNewService',
      'isLaptopUser',
      'toolList',
      'upgradeChecking',
      'uninstallLoadingFlag',
      'uninstallSearchValue',
      'uninstallSoftwareList',
    ]),
  },
  created() {
    const timeStart = new Date();
    this.setDebugInfos(['HomePage', 'HomePage Created']);
    localStorage.setItem('iDesk-init', 'initing');
    // for TripPal iDesk page background socket kill(delete after TripPal V2.8)
    setTimeout(() => {
      localStorage.removeItem('iDesk-init');
    }, 5000);
    // get the device info from TripPal
    window.addEventListener('getDeviceInfoCallback', this.getDeviceInfo);
    if (this.mockMode) this.testMethod();
    window.dispatchEvent(
      new CustomEvent('getDeviceInfo', {
        detail: {
          hostname: true,
        },
        // eslint-disable-next-line comma-dangle
      })
    );
    // auth code check
    const { code, state } = this.$route.query;
    console.log('route query', this.$route.query);
    this.setUpgradeChecking(true);
    this.checkAuthCode(state, code);
    // get user details(API)
    this.getUserInfo(code).then(() => {
      localStorage.setItem('USER', this.userInfo.empcode);
      // UBTUtil.setLoginName(this.userInfo.empcode);
      // ubtjs();
      this.pvId = ubtRegister('Home');
      this.setPvId(this.pvId);
      // get language data(API)
      this.getLanguagePackage().then(async () => {
        // device check(trip pc or user pc)(API)
        await this.checkTripPc();
        if (!this.isTripPc) {
          this.showError('pcerror');
          return;
        }
        ubtSendTrace(245277, 'home_socket', 'init start', '', '', '', this.pvId);
        // init main service websocket 1
        const mainServiceWs = socket.initSocketEntity(0);
        mainServiceWs.onopen = () => {
          console.log('open socket 0 success');
          socket.setSocketCalled(0);
          // route to home grid
          this.$router.push(state ? `/home_grid?command=${state}` : 'home_grid');
          const pageTimeCost = new Date().getTime() - timeStart.getTime();
          console.log('page init time cost ', pageTimeCost);
          this.saveLog({
            title: 'pageload_cost',
            target: 'HomePage > HomeGrid',
            description: pageTimeCost,
          });
          // init main service websocket 2
          const mainServiceWs2 = socket.initSocketEntity(1);
          mainServiceWs2.onopen = () => {
            socket.setSocketCalled(1);
            console.log('open socket 1 success');
            this.initPromise = new Promise((resolve, reject) => {
              socket.sendSocket(0, "({ model: 'init', data: '', level: '' })", (res) => {
                const datas = JSON.parse(res);
                if (res.includes('No such command.')) {
                  this.setIsNewService(false);
                  ubtSendTrace(245277, 'home_socket', 'error', 'old service', '', '', this.pvId);
                } else if (datas.result === 'failed') reject(datas.error);
                resolve(datas);
              });
            });
            this.initPromise
              .then((dt) => {
                this.mainServiceInitCallback(dt, timeStart);
                // first use check(show ad imgs)
                if (!state) {
                  if (this.languages.showAd === 'show' || this.isTestUser) {
                    const adShow = window.localStorage.getItem(`${this.languages.lan}_show_ad`);
                    if (!adShow) {
                      window.localStorage.setItem(`${this.languages.lan}_show_ad`, 'done');
                      this.dialogAdVisible = true;
                    }
                  }
                }
              })
              .catch((err) => {
                this.setErrorTips(`get init data failed >${err}`);
                ubtSendTrace(245277, 'home_socket', 'error', err, '', '', this.pvId);
                this.saveLog({
                  title: 'command_error',
                  target: 'service init command',
                  description: err,
                  reserve1: 'HomePage > get service init datas',
                });
                this.showError('socketerror');
              });
          };
          mainServiceWs2.onerror = () => {
            this.showError('socketerror');
          };
        };
        mainServiceWs.onerror = () => {
          this.showError('socketerror');
        };
      });
      // get iDesk grid details(API)
      this.getGridDetails();
      // user type check (isT, notS)(API)
      this.checkUserType();
      // ubt fn
    });
  },
  methods: {
    ...mapMutations([
      'setDebugMode',
      'setLanguage',
      'setErrorTips',
      'setWarnTips',
      'setIsT',
      'setNotS',
      'setIsSeven',
      'setHeaders',
      'setSoftDetails',
      'setSoftTabPage',
      'setSoftSearch',
      'setSelectSoftDetails',
      'setUpgradeSoftDetails',
      'setUpgradeSoftCount',
      'handleSoftSearch',
      'setErrorType',
      'setDeviceName',
      'setUserInfo',
      'setCurrentUser',
      'setIsTripPc',
      'setHomeHidden',
      'setSearchHidden',
      'setServiceVersion',
      'setAuthNodeData',
      'setMaxServiceVer',
      'setUninstallData',
      'setSoftCount',
      'setFooterWarn',
      'setAuthTap',
      'setDebugInfos',
      'setIsAdministrator',
      'setUacStatus',
      'setTestUser',
      'setShowFooter',
      'setLaptopUser',
      'setIsNewService',
      'setSocketIniting',
      'setUpgradeChecking',
      'setModelError',
      'setIsVpUser',
      'setPvId',
      'setLocalDomain',
      'setUninstallSearch',
      'setUninstallSoftwareList',
      'setApplyAdminPermission',
    ]),
    ...mapActions([
      'getLanguageData',
      'getCheckInfo',
      'getUserDetails',
      'userAuthQuery',
      'getTripPc',
      'saveLog',
      'getSoftVersion',
      'getSoftTypes',
      'getSoftDetails',
      'getAuthNode',
      'getServiceList',
      'getToolList',
      'saveVersionLog',
      'softwareInstall',
      'getSoftSearch',
      'getUpdateList',
      'checkAdminReboot',
    ]),
    checkAuthCode(state, code) {
      this.routeState = state;
      this.setDebugInfos(['HomePage > code', code]);
      this.setDebugInfos(['HomePage > state', state]);
      if (!this.mockMode && !code) {
        this.setWarnTips('HomePage > get code failed');
        this.saveLog({
          title: 'api_error',
          target: 'getCode',
          description: 'get auth code error',
          reserve1: 'HomePage > auth code check',
        });
        this.showError('apierror');
      }
    },
    async mainServiceInitCallback(dt, timeStart) {
      this.saveLog({
        title: 'debug_log',
        target: 'mainServiceInitCallback',
        description: 'check main service',
        reserve1: 'HomePage > mainServiceInitCallback',
        reserve4: JSON.stringify(dt),
      });
      // eslint-disable-next-line object-curly-newline
      const { user, uac, admins, health, pctype, localDomain } = { ...JSON.parse(dt.data) };
      const userNow = this.userInfo.username;
      const match = user.match(/\\([^\\]*)$/);
      const currentUser = match ? match[1] : userNow;
      this.setCurrentUser(currentUser);
      this.setDebugInfos([
        'Home > Service Init Data >',
        `user: ${userNow},uac: ${uac}, pctype: ${pctype}`,
      ]);
      this.setDebugInfos(['Home > Service Init Data > admins', admins]);
      this.setLaptopUser('Laptop|Notebook'.includes(pctype));
      this.setLocalDomain(localDomain);
      console.log(user, userNow, uac, admins, admins.toLowerCase()
        .includes(currentUser.toLowerCase()));
      const adminList = admins.toLowerCase().split('◎');
      const adminFlag = adminList.includes(currentUser.toLowerCase());
      this.setIsAdministrator(adminFlag);
      if (adminFlag && this.isLaptopUser) {
        const rebootFlag = await this.checkAdminReboot({
          account: userNow.toLowerCase(),
          desktopNum: this.deviceName,
        });
        if (rebootFlag) {
          this.setIsAdministrator(false);
        }
      }
      this.setUacStatus(uac);
      if (uac === 'ON') this.setWarnTips(this.languages.uacOn);
      this.updateCheck(health, 'SecModel.exe', '');
      // getUpdateInfo
      const updateList = await this.getUpdateList();
      const healthMap = {};
      health.forEach((h) => {
        healthMap[h.name] = h;
      });
      console.log('updateList', updateList);
      console.log('healthMap', healthMap);
      // get service list(API)
      await this.getServiceInfo();
      // get tool list(API)
      await this.getToolsInfo();
      const newService = this.serviceList.filter((item) => item.name === this.maxServiceVer);
      // if (newService.length === 0) {
      //   this.$message.warning('High Service Missing!');
      //   return;
      // }
      console.log('newService', newService);
      this.saveLog({
        title: 'debug_log',
        target: 'mainServiceInitCallback',
        description: 'get new service',
        reserve1: 'HomePage > mainServiceInitCallback',
        reserve4: JSON.stringify(newService),
      });
      const localServiceVer = healthMap['iDeskService.exe'].version;
      // const newServiceVer = ;
      let reinstallFlag = false;
      for (let index = 0; index < updateList.length; index += 1) {
        const updateInfo = updateList[index];
        const {
          name, hash, upgradeCheck,
        } = updateInfo;
        const exe = `${name}.exe`;
        if (upgradeCheck === 0) {
          // eslint-disable-next-line no-prototype-builtins
          if (!healthMap.hasOwnProperty(exe)) {
            console.log(exe, 'not exist');
            reinstallFlag = true;
            break;
          }
          if (hash !== healthMap[exe].hash) {
            reinstallFlag = true;
            console.log(exe, 'version error');
            break;
          }
        }
      }
      // run soft model
      this.runSoftModel(health).then(() => {
        const softModelWs = socket.initSocketEntity(2);
        softModelWs.onopen = async () => {
          // init soft model websocket
          this.saveLog({
            title: 'soft model socket',
            target: 'HomePage > HomeGrid',
            description: 'connect success',
          });
          console.log('open socket 2 success');
          socket.setSocketCalled(2);
          if (reinstallFlag) {
            this.reinstallServcie(
              newService[0],
              this.deviceName,
              localServiceVer,
              this.maxServiceVer,
            );
            return;
          }
          this.saveVersionLog({
            pcName: this.deviceName,
            serviceVersion: this.mainServiceVer,
          });
          await this.getUpgradeSoftList();
          this.runInfoModel().then(() => {
            const infoModelWs = socket.initSocketEntity(3);
            infoModelWs.onopen = () => {
              // init info model websocket
              this.saveLog({
                title: 'info model socket',
                target: 'HomePage > HomeGrid',
                description: 'connect success',
              });
              this.setUpgradeChecking(false);
              console.log('open socket 3 success');
              socket.setSocketCalled(3);
              const timeStop = new Date();
              const timeCost = timeStop.getTime() - timeStart.getTime();
              console.log('scoket init time cost ', timeCost);
              ubtSendTrace(245277, 'home_socket', 'init finish', '', '', '', this.pvId);
              this.saveLog({
                title: 'socketInit_cost',
                target: 'HomePage > HomeGrid',
                description: timeCost,
              });
              this.setDebugInfos(['PageLoad Cost', timeCost]);
              // this.checkMainService(health);
              console.log('socketStatus', this.socketStatus);
              sendWebVitalsData();
            };
            infoModelWs.onerror = (error) => {
              console.log('connect failed: ', error);
              this.saveLog({
                title: 'info model socket',
                target: 'HomePage > HomeGrid',
                description: 'connect failed',
                reserve1: error.message,
              });
              this.showError('socketerror');
            };
            setTimeout(() => {
              console.log('info model ws state: ', softModelWs.readyState);
              if (infoModelWs.readyState === 0) {
                this.saveLog({
                  title: 'info model socket',
                  target: 'HomePage > HomeGrid',
                  description: 'connect failed',
                  reserve1: 'Port occupation',
                });
                this.showError('socketerror');
              }
            }, 5000);
          });
        };
        softModelWs.onerror = (error) => {
          console.log('connect failed: ', error);
          this.saveLog({
            title: 'soft model socket',
            target: 'HomePage > HomeGrid',
            description: 'connect failed',
            reserve1: error.message,
          });
          this.showError('socketerror');
        };
        setTimeout(() => {
          console.log('softModel ws state: ', softModelWs.readyState);
          if (softModelWs.readyState === 0) {
            this.saveLog({
              title: 'soft model socket',
              target: 'HomePage > HomeGrid',
              description: 'connect failed',
              reserve1: 'Port occupation',
            });
            this.showError('socketerror');
          }
        }, 5000);
      });
    },
    async getLocalDomain() {
      const toolName = 'CommonAssistant';
      const toolIdx = this.toolList.findIndex((v) => v.name === toolName);
      if (toolIdx === -1) {
        console.log('can not find ', toolName);
        this.setUpgradeChecking(false);
        return;
      }
      const res = await this.softwareInstall({
        account: this.userInfo.username,
        softwareId: this.toolList[toolIdx].id,
        pcName: this.deviceName,
      });
      this.downToolNew(toolName, this.toolList[toolIdx].id, res, (downloadRes) => {
        if (downloadRes === 'Down Failed') {
          this.setUpgradeChecking(false);
          return;
        }
        const toolData = {
          lan: 'tools',
          type: 'silent',
          username: `${this.userInfo.username}◎GetLocalDomain`,
          softid: this.toolList[toolIdx].id,
          path: res.data.encryptPath,
          key: res.data.key,
        };
        const socketDatas = tools.toUnicode(JSON.stringify(toolData));
        const runCmd = `({"level":"user", "method":"tool_run", "data":"${socketDatas}"})`;
        socket.sendSocket(2, runCmd, (rt) => {
          try {
            const rst = JSON.parse(rt);
            console.log(rst);
            if (rst.data === 'Tool Exited') {
              const result = JSON.parse(rst.info);
              if (result.flag) {
                this.setLocalDomain(result.data);
              }
            }
            this.setUpgradeChecking(false);
          } catch {
            this.setUpgradeChecking(false);
            console.log('get local domain failed');
          }
        });
      });
    },
    async reinstallServcie(service, pcCode, oldVer, newVer) {
      console.log('reinstall');
      console.log('service', service, pcCode, oldVer, newVer);
      this.setDebugInfos(['Home > updateService start', `${pcCode}, ${oldVer}, ${newVer}`]);
      this.loading = Loading.service({
        fullscreen: true,
        text: this.languages.serviceUpdate,
        background: 'rgba(0, 0, 0, 0.7)',
      });
      const createResult = await this.createSoftInstall(service.id, pcCode, oldVer, newVer);
      this.downloadSoftware(createResult, service.id).then(() => {
        socket.closeSocket(0);
        socket.closeSocket(1);
        const test = setInterval(() => {
          this.intervalCount += 1;
          socket.initSocket(0);
          if (this.intervalCount > 30) {
            this.setErrorTips('Home > updateService > reconnect socket timeout');
            this.intervalCount = 0;
            this.loading.close();
            clearInterval(this.socketConnectInterval);
            this.saveLog({
              title: 'socket_error',
              target: 'updateService',
              description: 'reconnect socket failed',
              reserve1: 'HomePage > updateService > timeout',
              reserve2: `old ver: ${oldVer}, new ver: ${newVer}`,
            });
            this.showError('apierror');
            return;
          }
          console.log('interval readyState >>>', this.socketStatus[0].readyState);
          if (this.socketStatus[0].socket !== '' && this.socketStatus[0].readyState === 1) {
            clearInterval(this.socketConnectInterval);
            this.setIsNewService(true);
            const protectServiceWs = socket.initSocketEntity(1);
            protectServiceWs.onopen = () => {
              socket.setSocketCalled(1);
              console.log('open socket 1 success');
              socket.sendSocket(0, '(test)', (initRes) => {
                this.setIsNewService(!initRes.includes('No such command.'));
                this.setServiceVersion(`Service Version: ${newVer}`);
                this.saveLog({
                  title: 'update_success',
                  target: 'updateService',
                  description: 'service update success',
                  reserve1: 'HomePage > updateService(new)',
                  reserve2: `old ver: ${oldVer}, new ver: ${newVer}`,
                });
                clearInterval(test);
                this.saveVersionLog({
                  pcName: this.deviceName,
                  serviceVersion: newVer,
                });
                this.initPromise = new Promise((resolve, reject) => {
                  socket.sendSocket(0, "({ model: 'init', data: '', level: '' })", (resp) => {
                    const datas = JSON.parse(resp);
                    if (resp.includes('No such command.')) {
                      this.setIsNewService(false);
                    } else if (datas.result === 'failed') reject(datas.error);
                    resolve(datas);
                  });
                });
                this.initPromise
                  .then(async (dt) => {
                    await this.mainServiceInitCallback(dt, new Date());
                    console.log('socketStatus', this.socketStatus);
                  })
                  .catch((err) => {
                    this.setErrorTips(`get init data failed >${err}`);
                    this.saveLog({
                      title: 'command_error',
                      target: 'service init command',
                      description: err,
                      reserve1: 'HomePage > get service init datas',
                    });
                    this.showError('socketerror');
                  });
                this.loading.close();
              });
            };
          }
        }, 2000);
      });
    },
    async downloadSoftware(res, mainServiceId) {
      const serviceData = {
        lan: 'service',
        type: 'install',
        username: this.userInfo.username,
        softid: mainServiceId,
        path: res.data.encryptPath,
        key: res.data.key,
      };
      const socketDatas = tools.toUnicode(JSON.stringify(serviceData));
      return new Promise((resolve) => {
        const downCommand = `({"level":"user", "method":"soft_download", "data":"${socketDatas}"})`;
        socket.sendSocket(2, downCommand, async (rs) => {
          const dres = JSON.parse(rs);
          if (dres.result === 'failed') {
            this.saveLog({
              title: 'download_error',
              target: 'updateService',
              description: dres.error,
              reserve1: 'updateService > new service download failed',
            });
            this.setErrorTips(`update service failed > ${dres.error}`);
            this.setWarnTips(this.languages.serviceUpdateFail);
            this.loading.close();
            this.showError('apierror');
            resolve();
            return;
          }
          if (dres.data === 'File Exist' || dres.data === 'Download Finished') {
            if (dres.data === 'Download Finished') {
              this.saveLog({
                title: 'download_success',
                target: 'updateService',
                description: 'normal',
                reserve1: 'updateService > download new servic success',
                reserve3: dres.data === 'File Exist' ? dres.data : dres.info,
              });
            }

            await tools.sleep(1000);
            const userLevel = this.isAdministrator ? 'user' : 'adf';
            const installCommand = `({"level":"${userLevel}", "method":"soft_install", "data":"${socketDatas}"})`;
            if (!this.isAdministrator) {
              this.initSoftModel('adf', () => {
                socket.sendSocket(2, installCommand, (ir) => {
                  if (ir.includes('success')) {
                    localStorage.removeItem('iDesk-init');
                    resolve();
                  }
                });
              });
            } else {
              socket.sendSocket(2, installCommand, (ir) => {
                if (ir.includes('success')) {
                  localStorage.removeItem('iDesk-init');
                  resolve();
                }
              });
            }
          }
        });
      });
    },
    async createSoftInstall(mainServiceId, pcCode, oldVer, newVer) {
      const res = await this.softwareInstall({
        account: this.userInfo.username,
        softwareId: mainServiceId,
        pcName: pcCode,
      });
      if (res.status !== 'success') {
        this.saveLog({
          title: 'api_error',
          target: 'updateService',
          description: res.data,
          reserve1: 'HomePage > updateService',
          reserve2: `old ver: ${oldVer}, new ver: ${newVer}`,
        });
        this.setErrorTips('Home > updateService > get service api error');
        this.loading.close();
        this.showError('apierror');
      }
      return res;
    },
    runSoftModel() {
      return new Promise((resolve) => {
        console.log('start run soft model');
        this.runModel('soft', 0).then((res) => {
          console.log('run soft model ', res);
          if (res !== 'success') {
            this.setWarnTips(this.languages.softModelRunError);
            this.showError('apierror');
            ubtSendTrace(
              245277,
              'home_socket',
              'error',
              this.languages.softModelRunError,
              '',
              '',
              this.pvId,
            );
          }
          resolve();
        });
      });
    },
    runInfoModel() {
      return new Promise((resolve) => {
        console.log('start run info model');
        this.runModel('info', 1).then((iRes) => {
          if (iRes === 'failed') {
            this.setWarnTips(this.languages.infoModelRunError);
            ubtSendTrace(
              245277,
              'home_socket',
              'error',
              this.languages.infoModelRunError,
              '',
              '',
              this.pvId,
            );
          }
          resolve();
        });
      });
    },
    async getUserInfo(code) {
      if (!this.mockMode) {
        const getUserResult = await this.getUserDetails(code);
        if (getUserResult.status === 'failed') {
          this.setWarnTips('HomePage > get user details failed');
          this.setErrorTips(`getUserDetails failed: ${this.getUserResult.data}`);
          this.setDebugInfos([
            'Home > getUserDetails',
            `getUserDetails failed: ${this.getUserResult.data}`,
          ]);
          this.saveLog({
            title: 'api_error',
            target: 'getUserDetails',
            description: getUserResult.data,
            reserve1: 'HomePage > get user details',
          });
          this.showError('apierror');
          return;
        }
      }
      const { emplevel } = this.userInfo;
      this.setIsVpUser(!!(emplevel && emplevel.toUpperCase().indexOf('VP') > -1));
    },
    async getLanguagePackage() {
      const getLanguageData = await this.getLanguageData();
      if (getLanguageData.status === 'failed') {
        this.setWarnTips('HomePage > get language data failed');
        this.setErrorTips(`getLanguageData failed: ${this.getLanguageData.data}`);
        this.setDebugInfos([
          'HomePage > getLanguageData',
          `getLanguageData failed: ${this.getLanguageData.data}`,
        ]);
        this.saveLog({
          title: 'api_error',
          target: 'getLanguagePackage',
          description: getLanguageData.data,
          reserve1: 'HomePage > get language data',
        });
        this.showError('apierror');
      } else {
        this.saveLog({
          title: 'debug_log',
          target: 'getLanguagePackage',
          description: 'get language data success',
          reserve1: 'HomePage > getLanguagePackage',
          reserve4: '',
        });
        // choose language datas(cn/en) by url param  lan: zh-CN, en
        const sysLanguage = window.clientLanguage;
        this.setDebugInfos(['Home > sysLanguage', sysLanguage]);
        // eslint-disable-next-line operator-linebreak
        const lanPack =
          sysLanguage === 'zh-CN' || sysLanguage === undefined
            ? this.languageDatas.cnpack
            : this.languageDatas.enpack;
        this.setLanguage(lanPack);
        // get Software Datas(API)
        this.getSoftwareInfo();
      }
    },
    async checkTripPc() {
      if (!this.mockMode) {
        const getPcResult = await this.getTripPc(this.deviceName);
        if (getPcResult.status === 'failed') {
          this.setWarnTips('HomePage > device check failed');
          this.setErrorTips(`device check failed: ${getPcResult.data}`);
          this.saveLog({
            title: 'api_error',
            target: 'getTripPc',
            description: getPcResult.data,
            reserve1: 'HomePage > device check',
          });
          this.showError('apierror');
          return;
        }
      }
      this.setDebugInfos(['Home > trip device', this.isTripPc]);
      this.saveLog({
        title: 'login_pc',
        target: 'device check',
        description: this.isTripPc ? 'tripPc' : 'userPc',
        reserve1: 'HomePage > device check',
      });
      // if (!this.isTripPc) {
      //   this.showError('pcerror');
      // }
      // return this.isTripPc;
    },
    async getSoftwareInfo() {
      await this.getSoftDatas(this.languages.lan);
      if (this.mockMode) {
        this.setAuthNodeData(homeMock.data.authNodeData);
        this.setMaxServiceVer(homeMock.data.maxServiceVer);
      }
    },
    async getGridDetails() {
      if (!this.mockMode) {
        const result = await this.getAuthNode();
        if (result.status === 'failed') {
          this.setWarnTips('HomePage > get grid details failed');
          this.setErrorTips(`HomePage > getAuthNode failed: ${result.data}`);
          this.saveLog({
            title: 'api_error',
            target: 'getAuthNode',
            description: result.data,
            reserve1: 'HomePage > getAuthNode',
          });
          this.showError('apierror');
        }
      }
    },
    async getServiceInfo() {
      const serviceDatas = await this.getServiceList('services');
      if (serviceDatas.status === 'failed') {
        this.setWarnTips('HomePage > get service list failed');
        this.setErrorTips(`HomePage > getServiceList failed: ${serviceDatas.data}`);
        this.saveLog({
          title: 'api_error',
          target: 'getServiceList',
          description: serviceDatas.data,
          reserve1: 'HomePage > get service list',
        });
        this.showError('apierror');
      }
    },
    async getToolsInfo() {
      const toolDatas = await this.getToolList('tools');
      if (toolDatas.status === 'failed') {
        this.setWarnTips('HomePage > get tool list failed');
        this.setErrorTips(`HomePage > getToolList failed: ${toolDatas.data}`);
        this.saveLog({
          title: 'api_error',
          target: 'getToolList',
          description: toolDatas.data,
          reserve1: 'HomePage > get tool list',
        });
        this.showError('apierror');
      }
    },
    async getUpdateInfo() {
      const toolDatas = await this.getUpdateList();
      if (toolDatas.status === 'failed') {
        this.setWarnTips('HomePage > get update list failed');
        this.setErrorTips(`HomePage > getUpdateInfo failed: ${toolDatas.data}`);
        this.saveLog({
          title: 'api_error',
          target: 'getUpdateInfo',
          description: toolDatas.data,
          reserve1: 'HomePage > get tool list',
        });
        this.showError('apierror');
      }
    },
    async checkUserType() {
      const account = this.userInfo.username;
      const type = 'add_admin';
      const result = await this.getCheckInfo(`${type}/${account}/${this.deviceName}`);
      if (result.status === 'failed') {
        this.setErrorTips('HomePage > getCheckInfo failed');
        this.setDebugInfos(['HomePage > User Check Failed', result.data]);
        this.saveLog({
          title: 'api_error',
          target: 'getCheckInfo',
          description: result.data,
          reserve1: 'HomePage > user type check',
        });
      } else {
        // eslint-disable-next-line object-curly-newline
        const { isT, notS, is7, isCurrentKey, applyAdminPermission } = result.data;
        this.setIsSeven(is7);
        this.setIsT(isT);
        this.setNotS(notS);
        this.setApplyAdminPermission(applyAdminPermission);
        this.setDebugInfos(['HomePage > is current device', isCurrentKey]);
        this.setDebugInfos(['HomePage > is T user', isT]);
        this.setDebugInfos(['HomePage > not S user', notS]);
      }
    },
    getStateType(item) {
      if (item.loading) return 'loading';
      switch (item.readyState) {
        case -1:
          return 'warning warn';
        case 0:
          return 'loading';
        case 1:
          return 'success success';
        case 2:
          return 'loading';
        case 3:
          return 'error danger';
        default:
          return 'question warn';
      }
    },
    async ModelUpdateCheck(health, modelName, runName, callback) {
      console.log('ModelUpdateCheck', modelName, runName);
      const modelIndex = this.toolList.findIndex((soft) => soft.name === modelName);
      if (modelIndex === -1) {
        callback(true);
        return;
      }
      const modelStatus = this.updateCheck(
        health,
        `${modelName}.exe`,
        // eslint-disable-next-line comma-dangle
        this.toolList[modelIndex].version
      );
      // console.log(modelName, modelStatus, runName, health);
      if (modelStatus === 'same') {
        callback(true);
        return;
      }
      // Model Update
      await this.updateModel(this.toolList[modelIndex], async (tRes) => {
        if (!tRes) {
          callback(false);
          return;
        }
        if (runName === 'service') {
          callback(true);
          return;
        }
        this.runModel(runName, 0).then((rRes) => {
          console.log('runModel > ', rRes);
          if (rRes === 'success') {
            callback(true);
          } else {
            callback(false);
          }
        });
      });
    },
    async updateModel(soft, callback) {
      const res = await this.softwareInstall({
        account: this.userInfo.username,
        softwareId: soft.id,
        pcName: this.deviceName,
      });
      if (res.status !== 'success') {
        this.saveLog({
          title: 'api_error',
          target: 'updateModel',
          description: `errors: ${res.data}`,
          reserve1: 'HomePage > updateModel > softwareInstall Api',
        });
        this.setErrorTips(`HomePage > updateModel > get model api error > ${res.data}`);
        this.showError('apierror');
        callback(false);
        return;
      }
      const modelData = {
        lan: 'tools',
        type: 'littletools',
        username: this.userInfo.username,
        softid: soft.id,
        path: res.data.encryptPath,
        key: res.data.key,
      };
      const socketDatas = tools.toUnicode(JSON.stringify(modelData));
      const downCommand = `({"level":"user", "method":"model_download", "data":"${socketDatas}"})`;
      socket.sendSocket(2, downCommand, async (ds) => {
        const dRes = JSON.parse(ds);
        if (dRes.result === 'failed') {
          this.saveLog({
            title: 'download_error',
            target: 'updateModel',
            description: dRes.error,
            reserve1: 'HomePage > updateModel',
            reserve2: `Download Model  > ${soft.name}`,
          });
          this.setErrorTips(`${soft.name} > Download Model Failed > ${dRes.error}`);
          callback(false);
          return;
        }
        if (dRes.data === 'File Exist' || dRes.data === 'Download Finished') {
          const replaceCommand = `({"level":"update", "model":"${soft.name}", "data":"c:\\\\Program Files"})`;
          if (dRes.data === 'Download Finished') await tools.sleep(1000);
          socket.sendSocket(0, replaceCommand, (ures) => {
            const uResult = JSON.parse(ures);
            if (uResult.result !== 'success') {
              this.saveLog({
                title: 'update_error',
                target: 'updateModel',
                description: uResult.error,
                reserve1: 'HomePage > updateModel',
              });
              callback(false);
              return;
            }
            this.saveLog({
              title: 'update_success',
              target: 'updateModel',
              description: `${soft.name} Update Success`,
              reserve1: 'HomePage > updateModel',
            });
            callback(true);
          });
        }
      });
    },
    updateCheck(checkData, name, targetVer) {
      const index = checkData.findIndex((item) => item.name === name);
      const localVer = index > -1 ? checkData[index].version : '0.0.0.0';
      this.setServiceVersion(`${this.serviceVersion}<br>
      ${name.replace('.exe', '')}: ${localVer}`);
      const compareResult = tools.versionCompare(localVer, targetVer);
      if (name === 'iDeskService.exe') this.mainServiceVer = localVer;
      if (!name.includes('Service')) return compareResult;
      return checkData[index].status !== 'Running' ? 'Service Error' : compareResult;
    },
    openAIChat() {
      if (this.isRunning) return;
      // window.location = this.languages.service;
      this.saveLog({
        title: 'jump_url',
        target: 'openAIChat',
        description: 'Helpdesk Service',
        reserve1: 'HomePage > Helpdesk Service',
      });
      tools.openUrl(this.languages.service);
      ubtSendTrace(245277, 'main_index', 'help', '', '', 'manhelp', this.pvId);
    },
    openConf() {
      if (this.isRunning) return;
      tools.openUrl(this.languages.confdoc);
      ubtSendTrace(245277, 'main_index', 'helpdoc', 'main_index', '', '', this.pvId);
    },
    goSoftwareApply() {
      if (this.isRunning) return;
      this.setHomeHidden(false);
      if (this.pageNow === 'SoftwareInstall') this.$router.push('/softapplication');
      if (this.pageNow === 'SoftwareInstallOld') this.$router.push('/softapply');
    },
    goHome() {
      if (this.isRunning || this.isErrorPage) return;
      this.setHomeHidden(true);
      this.setSearchHidden(true);
      this.getUpgradeSoftList();
      this.isVersionChecking = false;
      this.authInterval = false;
      this.$router.push('/home_grid');
    },
    showErrorInfo() {
      if (this.errorTips) this.$message.warning(this.errorTips);
    },
    downFixTool() {
      const downUrl = this.languages.repairTool;
      console.log(downUrl);
      if (downUrl !== '') tools.openUrl(downUrl);
    },
    showServiceVersion() {
      this.debugCount += 1;
      const showInfo = `${this.serviceVersion}
      <br>Device: ${this.deviceName}
      <br>User: ${this.userInfo.username}
      <br>IsTester: ${this.isTestUser}
      <br>Internet: ${this.internetAuth}
      <br>IsLaptop: ${this.isLaptopUser}
      <br>UAC: ${this.UacStatus}
      <br>IsAdmin: ${this.isAdministrator}`;
      if (this.debugCount >= 5) this.setDebugMode(true);
      this.$message({
        dangerouslyUseHTMLString: true,
        showClose: true,
        message: this.debugCount >= 5 ? `Debug Mode On<br>${showInfo}` : showInfo,
        type: 'success',
        duration: 5000,
      });
    },
    hideAdDialog() {
      this.dialogAdVisible = false;
    },
    showDebug() {
      if (this.debugCount >= 5 || this.mockMode) this.$router.push('/debug');
    },
    cleanStorage() {
      if (this.pageNow !== 'HomeGrid') return;
      window.localStorage.removeItem('cn_datas');
      window.localStorage.removeItem('en_datas');
      window.localStorage.removeItem('cn');
      window.localStorage.removeItem('en');
      window.localStorage.removeItem('isInstall');
      this.$message.success('Cleared!');
    },
    handleLanChange() {
      if (this.isRunning) return;
      if (!this.lanChange) return;
      this.setSoftSearch('');
      this.setFooterWarn('');
      this.authInterval = false;
      // eslint-disable-next-line operator-linebreak
      const lan =
        this.languages.lan === 'cn' ? this.languageDatas.enpack : this.languageDatas.cnpack;
      this.setLanguage(lan);
      const recommendList =
        this.languages.lan === 'cn' ? this.recommendSoftware : this.recommendSoftwareEn;
      console.log('handleLanChange', lan, this.pageNow);
      switch (this.pageNow) {
        case 'SoftwareInstall':
          this.setSoftTabPage(recommendList > 0 ? 'recommend' : 'common');
          this.getSoftDatas(this.languages.lan, () => {
            this.setSelectSoftDetails(recommendList > 0 ? 'recommend' : 'common');
          });
          setTimeout(() => {
            this.checkUninstallResult();
          }, 1000);
          break;
        case 'SoftwareDeploy':
          this.getSoftDatas(this.languages.lan, () => {});
          break;
        case 'SoftwareUpgrade':
        case 'HomeGrid':
          this.getSoftDatas(this.languages.lan, () => {
            this.getUpgradeSoftList();
          });
          break;
        default:
          break;
      }
      ubtSendTrace(245277, 'main_index', 'language', this.languages.lan, '', '', this.pvId);
    },
    getDeviceInfo(e) {
      this.setDeviceName(e.detail.hostname);
      window.removeEventListener('getDeviceInfoCallback', this.getDeviceInfo);
    },
    handleSearch(e) {
      this.setSoftSearch(e);
      if (this.isSearching) {
        clearTimeout(this.isSearching);
        this.isSearching = null;
      }
      this.isSearching = setTimeout(async () => {
        await this.getSoftSearch(e);
        // this.setSoftSearch(e);
        // this.handleSoftSearch(this.searchValue);
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
          this.checkUninstallResult();
        }, 300);
      }, 600);
    },

    testMethod() {
      const { userInfo } = homeMock;
      this.setUserInfo(userInfo);
      this.setIsTripPc(true);
      this.setTestUser(true);
    },

    async getSoftDatas(lan, callback) {
      const localVersion = window.localStorage.getItem(lan);
      let localSoftDatas = window.localStorage.getItem(`${lan}_datas`);
      if (localSoftDatas === '[]') {
        localSoftDatas = null;
        window.localStorage.removeItem(`${lan}_datas`);
      }
      /* get soft version */
      const gsvResult = await this.getSoftVersion(lan);
      this.saveLog({
        title: 'debug_log',
        target: 'getSoftDatas',
        description: 'get soft version',
        reserve1: 'HomePage > getSoftDatas',
        reserve4: JSON.stringify(this.softVersion),
      });
      if (gsvResult.status === 'failed') {
        this.saveLog({
          title: 'api_error',
          target: 'getSoftVersion',
          description: gsvResult.data,
          reserve1: 'HomePage > getSoftDatas',
        });
      }
      /* get soft types */
      const gstResult = await this.getSoftTypes(lan);
      this.saveLog({
        title: 'debug_log',
        target: 'getSoftDatas',
        description: 'get soft types',
        reserve1: 'HomePage > getSoftDatas',
        reserve4: JSON.stringify(this.softTypeList),
      });
      if (gstResult.status === 'failed') {
        this.saveLog({
          title: 'api_error',
          target: 'getSoftTypes',
          description: gstResult.data,
          reserve1: 'HomePage > getSoftDatas',
        });
      }
      /* query user apply softwares */
      const quaResult = await this.userAuthQuery({
        empCode: this.userInfo.empcode,
        pcName: this.deviceName,
      });
      if (quaResult.status === 'failed') {
        this.saveLog({
          title: 'api_error',
          target: 'userAuthQuery',
          description: quaResult.data,
          reserve1: 'HomePage > getSoftDatas',
        });
      }
      console.log('this.softVersion', localVersion, this.softVersion);
      if (!localVersion || localVersion !== this.softVersion || !localSoftDatas) {
        console.log('get new language data');
        window.localStorage.setItem(lan, this.softVersion);
        window.localStorage.removeItem(`${lan}_datas`);
        const gsdResult = await this.getSoftDetails(lan);
        if (gsdResult.status === 'failed') {
          this.saveLog({
            title: 'api_error',
            target: 'getSoftDetails',
            description: gsdResult.data,
            reserve1: 'HomePage > getSoftDatas',
          });
        } else {
          window.localStorage.setItem(`${lan}_datas`, JSON.stringify(this.softTotalDetailDatas));
        }
      }
      /* method for AuthSoftware Filter */
      const softDatas = window.localStorage.getItem(`${lan}_datas`);
      const softList = JSON.parse(softDatas);
      if (softDatas && softDatas.length > 0) {
        if (this.testTypeId !== 0) {
          softList.forEach((el, index) => {
            if (el.typeId === this.testTypeId) {
              softList.splice(index, 1);
            }
          });
          this.setSoftDetails(softList);
        } else {
          this.setSoftDetails(JSON.parse(softDatas));
        }
      }
      if (callback) callback();
    },
    async getUpgradeSoftList() {
      if (this.isVersionChecking) return;
      this.isVersionChecking = true;
      // this.setUpgradeSoftDetails([]);
      this.setUpgradeSoftCount(0);
      let checkDatas = '';
      const softDatas = window.localStorage.getItem(`${this.languages.lan}_datas`);
      const softList = JSON.parse(softDatas);
      let softLength = 0;
      if (softList) {
        softLength = softList.length;
      }
      this.saveLog({
        title: 'debug_log',
        target: 'getUpgradeSoftList > softDatas',
        description: 'get localStorage softDatas',
        reserve1: 'HomePage > getUpgradeSoftList',
        reserve4: softLength,
      });
      if (softList && softList.length > 0) {
        softList.forEach((el) => {
          const checkSoft = {};
          if (el.upgradeCheck === 1) {
            checkSoft.name = el.regName;
            checkSoft.version = el.version;
            // 增加注册表名称匹配方式
            checkSoft.matchType = el.upgradeMatchType;
            checkDatas += `${JSON.stringify(checkSoft)}◎`;
          }
        });
      }
      if (checkDatas === '') {
        this.isVersionChecking = false;
        this.setUpgradeSoftDetails([]);
        this.setSoftCount(0);
        return;
      }
      if (!this.isNewService) {
        await socket.sendSocket(1, `idesk_versioncheck(${checkDatas})`, (res) => {
          console.log('idesk_versioncheck', res);
          this.isVersionChecking = false;
          if (res.result === 'success') {
            const upgradeList = [];
            let upgradeCount = 0;
            softList.forEach((el) => {
              if (el.upgradeCheck === 1) {
                const itm = el;
                switch (res[el.regName]) {
                  case '>':
                    itm.upgradeStatus = 1;
                    upgradeCount += 1;
                    break;
                  case 'N':
                    itm.upgradeStatus = 2;
                    break;
                  case '<>':
                    itm.upgradeStatus = 2;
                    break;
                  default:
                    itm.upgradeStatus = 0;
                    break;
                }
                upgradeList.push(itm);
                this.setUpgradeSoftDetails(upgradeList);
                this.setUpgradeSoftCount(upgradeCount);
              }
            });
            if (!this.redirectMode) {
              this.setSoftCount(upgradeList.length);
            }
          }
        });
      } else {
        const verCmd = { level: 'user', method: 'check_version', data: checkDatas };
        this.saveLog({
          title: 'debug_log',
          target: 'getUpgradeSoftList > checkDatas',
          description: 'check softData',
          reserve1: 'HomePage > getUpgradeSoftList',
          reserve4: checkDatas,
        });
        socket.sendSocket(2, `(${JSON.stringify(verCmd)})`, (rs) => {
          if (rs === 'failConnect') {
            this.setModelError(true);
            this.$message.warning(this.languages.modelError);
            this.setErrorTips(`check version failed >${rs}`);
            this.saveLog({
              title: 'command_error',
              target: 'getUpgradeSoftList > check version failed',
              description: rs,
              reserve1: 'HomePage > getUpgradeSoftList',
            });
            this.setWarnTips(this.languages.modelError);
            return;
          }
          console.log('check_version', rs);
          const verResult = JSON.parse(rs);
          // socket.closeSocket(2);
          this.isVersionChecking = false;
          if (verResult.result === 'success') {
            const datas = JSON.parse(verResult.data);
            const upgradeList = [];
            let upgradeCount = 0;
            softList.forEach((el) => {
              if (el.upgradeCheck === 1) {
                const itm = el;
                switch (datas[el.regName]) {
                  case '>':
                    itm.upgradeStatus = 1;
                    upgradeCount += 1;
                    break;
                  case 'N':
                    itm.upgradeStatus = 2;
                    break;
                  case '<>':
                    itm.upgradeStatus = 2;
                    break;
                  default:
                    itm.upgradeStatus = 0;
                    break;
                }
                upgradeList.push(itm);
                this.setUpgradeSoftDetails(upgradeList);
                this.setUpgradeSoftCount(upgradeCount);
              }
            });
            if (!this.redirectMode) {
              this.setSoftCount(upgradeList.length);
            }
          }
        });
      }
    },
    async updateService(service, pcCode, oldVer, newVer) {
      console.log('service', service, pcCode, oldVer, newVer);
      this.setDebugInfos(['Home > updateService start', `${pcCode}, ${oldVer}, ${newVer}`]);
      this.loading = Loading.service({
        fullscreen: true,
        text: this.languages.serviceUpdate,
        background: 'rgba(0, 0, 0, 0.7)',
      });

      const res = await this.softwareInstall({
        account: this.userInfo.username,
        softwareId: service.id,
        pcName: pcCode,
      });
      if (res.status !== 'success') {
        this.saveLog({
          title: 'api_error',
          target: 'updateService',
          description: res.data,
          reserve1: 'HomePage > updateService',
          reserve2: `old ver: ${oldVer}, new ver: ${newVer}`,
        });
        this.setErrorTips('Home > updateService > get service api error');
        this.loading.close();
        this.showError('apierror');
        return;
      }
      const serviceData = {
        lan: 'service',
        type: 'install',
        username: this.userInfo.username,
        softid: service.id,
        path: res.data.encryptPath,
        key: res.data.key,
      };
      const socketDatas = tools.toUnicode(JSON.stringify(serviceData));
      if (this.isNewService) {
        // new service update to old service
        this.updatePromise = new Promise((resolve) => {
          const downCommand = `({"level":"user", "method":"soft_download", "data":"${socketDatas}"})`;
          socket.sendSocket(2, downCommand, async (rs) => {
            const dres = JSON.parse(rs);
            if (dres.result === 'failed') {
              this.saveLog({
                title: 'download_error',
                target: 'updateService',
                description: dres.error,
                reserve1: 'updateService > new service download failed',
              });
              this.setErrorTips(`update service failed > ${dres.error}`);
              this.setWarnTips(this.languages.serviceUpdateFail);
              this.loading.close();
              this.showError('apierror');
              resolve();
              return;
            }
            if (dres.data === 'File Exist' || dres.data === 'Download Finished') {
              if (dres.data === 'Download Finished') {
                this.saveLog({
                  title: 'download_success',
                  target: 'updateService',
                  description: 'normal',
                  reserve1: 'updateService > download new servic success',
                  reserve3: dres.data === 'File Exist' ? dres.data : dres.info,
                });
              }

              await tools.sleep(1000);
              const userLevel = this.isAdministrator ? 'user' : 'adf';
              const installCommand = `({"level":"${userLevel}", "method":"soft_install", "data":"${socketDatas}"})`;
              if (!this.isAdministrator) {
                this.initSoftModel('adf', () => {
                  socket.sendSocket(2, installCommand, (ir) => {
                    if (ir.includes('success')) {
                      localStorage.removeItem('iDesk-init');
                      resolve();
                    }
                  });
                });
              } else {
                socket.sendSocket(2, installCommand, (ir) => {
                  if (ir.includes('success')) {
                    localStorage.removeItem('iDesk-init');
                    resolve();
                  }
                });
              }
            }
          });
        });
      } else {
        // old service update to new service
        this.updatePromise = new Promise((resolve) => {
          socket.sendSocket(0, `idesk_download(${socketDatas})`, (rs) => {
            if (rs.result !== 'download success') {
              this.setErrorTips(`Home > updateService > service download error > ${rs.error_msg}`);
              this.saveLog({
                title: 'download_error',
                target: 'updateService',
                softname: 'iDeskInstall',
                softid: 68,
                description: res.error_msg,
                reserve1: 'HomePage > updateService',
                reserve2: `old ver: ${oldVer}, new ver: ${newVer}`,
              });
              this.loading.close();
              this.showError('apierror');
              return;
            }
            this.saveLog({
              title: 'download_success',
              target: 'updateService',
              softname: 'iDeskInstall',
              softid: 68,
              description: 'service download success',
              reserve1: 'HomePage > updateService',
              reserve2: `old ver: ${oldVer}, new ver: ${newVer}`,
              reserve4: rs.downway,
            });
            this.showSocketStatus = true;
            socket.sendSocket(0, `idesk_install(${socketDatas})`); // this install has no feedback
            localStorage.removeItem('iDesk-init');
            resolve();
          });
        });
      }
      this.updatePromise.then(async () => {
        setTimeout(() => {
          const mainServiceWs = socket.initSocketEntity(0);
          mainServiceWs.onopen = () => {
            console.log('open socket 0 success');
            socket.setSocketCalled(0);
            // init protect service websocket
            const protectServiceWs = socket.initSocketEntity(1);
            protectServiceWs.onopen = () => {
              socket.setSocketCalled(1);
              console.log('open socket 1 success');
              socket.sendSocket(0, '(test)', (initRes) => {
                this.setIsNewService(!initRes.includes('No such command.'));
                if (this.isNewService) {
                  this.setServiceVersion(`Service Version: ${newVer}`);
                  this.saveLog({
                    title: 'update_success',
                    target: 'updateService',
                    description: 'service update success',
                    reserve1: 'HomePage > updateService(new)',
                    reserve2: `old ver: ${oldVer}, new ver: ${newVer}`,
                  });
                  this.saveVersionLog({
                    pcName: this.deviceName,
                    serviceVersion: newVer,
                  });
                  this.initPromise = new Promise((resolve, reject) => {
                    socket.sendSocket(0, "({ model: 'init', data: '', level: '' })", (resp) => {
                      const datas = JSON.parse(resp);
                      if (resp.includes('No such command.')) {
                        this.setIsNewService(false);
                      } else if (datas.result === 'failed') reject(datas.error);
                      resolve(datas);
                    });
                  });
                  this.initPromise
                    .then(async (dt) => {
                      await this.mainServiceInitCallback(dt, new Date());
                      console.log('socketStatus', this.socketStatus);
                    })
                    .catch((err) => {
                      this.setErrorTips(`get init data failed >${err}`);
                      this.saveLog({
                        title: 'command_error',
                        target: 'service init command',
                        description: err,
                        reserve1: 'HomePage > get service init datas',
                      });
                      this.showError('socketerror');
                    });
                  this.loading.close();
                }
              });
            };
          };
        }, 30000);
      });
    },
    showError(error) {
      this.setErrorType(error);
      this.$router.push('/error');
    },
    async checkUninstallResult() {
      if (this.pageNow !== 'SoftwareInstall') return;
      const uninstallRegList = this.selectSoftDetails
        .filter((item) => item.uninstall === 1 && item.regName !== '')
        .map((itm) => {
          const unstr = {};
          unstr.name = itm.regName;
          unstr.version = itm.version;
          switch (itm.uninstallParams) {
            case 'ISMSI':
              unstr.path = 'MSI';
              break;
            case 'ISEXE':
              unstr.path = 'EXE';
              break;
            default:
              unstr.path = itm.path.substring(itm.path.lastIndexOf('.') + 1);
              break;
          }
          return JSON.stringify(unstr);
        });
      let checkData = '';
      uninstallRegList.forEach((el) => {
        // replace for soft with () in reg
        checkData += this.isNewService ? `${el}◎` : `${el.replace('(', '[').replace(')', ']')}◎`;
      });
      if (checkData !== '') {
        const command = { level: 'user', method: 'check_uninstall', data: checkData };
        const checkCmd = this.isNewService
          ? `(${JSON.stringify(command)})`
          : `idesk_uninstallcheck(${checkData})`;
        const port = this.isNewService ? 2 : 1;
        await socket.sendSocket(port, checkCmd, (ucs) => {
          console.log('uninstall check', ucs);
          if (!this.isNewService) {
            if (ucs.result) this.setUninstallData(ucs);
            return;
          }
          const checkResult = JSON.parse(ucs);
          if (checkResult.result === 'success') {
            this.setUninstallData(JSON.parse(checkResult.data));
          } else {
            this.saveLog({
              title: 'command_error',
              target: 'checkUninstallResult',
              description: checkResult.error,
              reserve1: 'HomePage > checkUninstallResult',
            });
          }
        });
      }
    },
    async initSoftModel(level, callback) {
      this.setSocketIniting(true);
      const initCommand = `({"model":"SoftModel","data":"RunSoftModel","level":"${level}"})`;
      await socket.sendSocket(1, initCommand, async (res) => {
        socket.initSocket(2);
        this.restartSoftModelInterval = setInterval(() => {
          console.log(this.socketStatus[2].socket.readyState);
          if (this.socketStatus[2].socket.readyState === 1) {
            this.setSocketIniting(false);
            if (callback) callback(res);
            clearInterval(this.restartSoftModelInterval);
          }
        }, 100);
      });
    },
    runModel(name, serviceIndex) {
      return new Promise((resolve) => {
        const level = this.isAdministrator ? 'user' : 'ads';
        const modelCommand = {
          soft: `({"model":"SoftModel","data":"RunSoftModel","level":"${level}"})`,
          info: '({"model":"InfoModel","data":"RunInfoModel","level":"ads"})',
        };
        socket.sendSocket(serviceIndex, modelCommand[name], async (res) => {
          const srt = JSON.parse(res);
          if (srt.result === 'failed') {
            this.saveLog({
              title: 'model_error',
              target: `Run ${name}Model Failed`,
              description: srt.error,
              reserve1: 'HomePage > runModel',
            });
            resolve('error');
          }
          resolve('success');
        });
      });
    },
    async downToolNew(scriptName, softId, softData, callback) {
      const toolData = {
        lan: 'tools',
        type: 'littletools',
        username: this.userInfo.username,
        softid: softId,
        path: softData.data.encryptPath,
        key: softData.data.key,
      };
      const socketDatas = tools.toUnicode(JSON.stringify(toolData));
      const downCommand = `({"level":"user", "method":"tool_download", "data":"${socketDatas}"})`;
      socket.sendSocket(2, downCommand, async (ds) => {
        const dRes = JSON.parse(ds);
        if (dRes.result === 'failed') {
          this.saveLog({
            title: 'download_error',
            target: 'downToolNew',
            description: dRes.error,
            reserve1: 'HomePage > downToolNew',
            reserve2: `Download Little Tool > ${scriptName}`,
          });
          this.setErrorTips(`${scriptName} > Download Little Tool > ${dRes.error}`);
          const { downBlock, blockTips } = this.languages;
          const error = dRes.error.toLowerCase();
          if (error.indexOf(downBlock) > -1) {
            this.$message.warning({ message: blockTips, duration: 0, showClose: true });
            this.$router.push('home_grid');
          } else {
            this.$message.warning(this.languages.toolDownFail);
            if (callback) callback('Down Failed');
          }
          return;
        }
        if (dRes.data === 'File Exist' || dRes.data === 'Download Finished') {
          if (dRes.data === 'Download Finished') {
            this.saveLog({
              title: 'download_success',
              target: 'downToolNew',
              description: 'runUserToolNew',
              reserve1: 'HomePage > downToolNew',
              reserve2: `Download Little Tool > ${scriptName}`,
              reserve3: dRes.info,
            });
          }
          if (callback) callback();
        }
      });
    },
    handleUninstallSearch(e) {
      this.setUninstallSearch(e);
      if (this.isSearching) {
        clearTimeout(this.isSearching);
        this.isSearching = null;
      }
      this.isSearching = setTimeout(async () => {
        const uninstallSoftwareCache = JSON.parse(localStorage.getItem('UNINSTALL_SOFTWARE'));
        let searchResult = [];
        if (this.uninstallSearchValue === '') {
          searchResult = uninstallSoftwareCache;
        } else {
          searchResult = uninstallSoftwareCache.filter(
            (v) => v.display.toLowerCase().includes(e.toLowerCase()),
          );
        }
        this.setUninstallSoftwareList(searchResult);
        this.setSoftCount(this.uninstallSoftwareList.length);
      }, 600);
    },
  },
  beforeDestroy() {
    socket.closeAllSocket();
    window.removeEventListener('getDeviceInfoCallback', this.getDeviceInfo);
    localStorage.removeItem('iDesk-init');
    clearInterval(this.socketConnectInterval);
  },
};
</script>

<style lang="scss" scoped>
.home-container {
  height: 100%;
}

.el-header {
  background-image: linear-gradient(to right, #1466de, #2695f7);
  display: flex;
  padding-left: 0;
  align-items: center;
  color: #fff;

  .socket-container {
    border-radius: 5px;
    position: absolute;
    height: 16px;
    top: 5px;
    right: 5px;
    display: flex;

    .status-warn {
      color: #f56c6c;
      background: #fff;
      border-radius: 10px;
      line-height: 16px;
      animation: flash 1.5s linear infinite;
    }

    @keyframes flash {
      0% {
        opacity: 0;
      }

      20% {
        opacity: 0.5;
      }

      100% {
        opacity: 1;
      }
    }

    .status-detail {
      display: flex;
      margin-left: 3px;
      background-image: linear-gradient(to bottom, #fff 33%, #ccc 50%, #fff 100%);
      color: #666;
      font-size: 12px;
      border-radius: 8px;
      line-height: 14px;
      font-size: 16px;

      .status-name {
        margin-left: 3px;
      }

      .status-state {
        background: #fff;
        border-radius: 10px;
      }

      .warn {
        color: #e6a23c;
      }

      .success {
        color: #67c23a;
      }

      .danger {
        color: #f56c6c;
      }
    }
  }

  .icon-help,
  .icon-service,
  .icon-lan,
  .icon-home {
    position: absolute;
    cursor: pointer;
    height: 28px;
    width: 28px;
    top: 30px;
  }

  .icon-idesk,
  .icon-gohome {
    position: absolute;
    left: 24px;
    top: 18px;
    height: 48px;
    width: 48px;
  }

  .icon-gohome {
    cursor: pointer;
  }

  .soft-search {
    position: absolute;
    left: 92px;
    top: 26px;
    width: 250px;
  }

  .button-apply,
  .button-license {
    position: absolute;
    left: 352px;
    top: 26px;
    width: 110px;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    color: #1466de;
    background-color: #fff;
    border-radius: 4px;
    cursor: pointer;
  }

  .button-license {
    left: 470px;

    img {
      width: 20px;
      margin-bottom: -5px;
    }
  }

  .button-disable {
    cursor: no-drop;
  }

  .button-apply-eng {
    font-size: 13px;
  }

  .icon-home {
    right: 20px;
  }

  .icon-lan {
    right: 68px;
  }

  .icon-service {
    right: 116px;
  }

  .icon-help {
    right: 164px;
  }
}

.el-main {
  background-color: #fff;
}

.soft-footer {
  position: fixed;
  bottom: 0;
  // left: 81px;
  left: 0;
  right: 0;
  height: 30px;
  line-height: 30px;
  text-align: right;
  padding-right: 20px;
  font-size: 14px;
  // padding-top: 5px;
  background-color: #f4f4f5;
  border-top: 1px solid rgba(100, 100, 100, 0.3);
}

.footer-tips,
.footer-policy,
.footer-warn {
  position: absolute;
  left: 10px;
  font-size: 10px;
}

.footer-policy {
  font-size: 14px;
}

.footer-warn {
  font-size: 14px;
  color: red;
}

.hidden {
  display: none !important;
}

.debug-control {
  display: flex;
  position: absolute;
  left: 5px;
  top: 5px;
  height: 15px;
  cursor: pointer;

  i {
    margin-right: 10px;
  }
}

.show-socket {
  position: absolute;
  width: 15px;
  height: 15px;
  right: 0;
  top: 55px;
}
</style>

<style>
.tooltip-style {
  background-color: rgba(0, 0, 0, 0.6) !important;
  padding: 5px !important;
  margin-top: 5px !important;
}
.el-input__inner {
  font-size: 14px;
}
</style>
